"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorTypeLookup = exports.DEFAULT_ERROR_MAP = void 0;
var LocationSearchErrors;
(function (LocationSearchErrors) {
    LocationSearchErrors["ZERO_RESULTS"] = "ZERO_RESULTS";
    LocationSearchErrors["DEFAULT"] = "DEFAULT";
})(LocationSearchErrors || (LocationSearchErrors = {}));
exports.DEFAULT_ERROR_MAP = {
    ZERO_RESULTS: 'We couldn\'t find any results for this search, please try again',
    DEFAULT: 'An error occurred, please try again'
};
const errorTypeLookup = (errorType, errorMap = exports.DEFAULT_ERROR_MAP) => {
    const matched = Object.keys(errorMap).find((e) => e === errorType);
    return matched ? errorMap[matched] : errorMap.DEFAULT;
};
exports.errorTypeLookup = errorTypeLookup;
//# sourceMappingURL=util.js.map